(function () {
  document.querySelectorAll('[data-engraving-root]').forEach(root => {
    const id = root.dataset.engravingId;

    const input1 = root.querySelector('#engraving-input-1'); // woman input
    const input2 = root.querySelector('#engraving-input-2'); // man input
    const saveBtn = root.querySelector('#engraving-ok-button');
    const resetBtn = root.querySelector('.reset-btn');
    const status = root.querySelector('.save-status');
    const propEngraving = root.querySelector('.prop-engraving');

    const czcionka = propEngraving.dataset.czcionka;
    const man = propEngraving.dataset.man;
    const woman = propEngraving.dataset.woman;

    const overlay1TP = root.querySelector('.engraving-textpath-1');
    const overlay2TP = root.querySelector('.engraving-textpath-2');
    const overlay1Text = overlay1TP ? overlay1TP.parentNode : null;
    const overlay2Text = overlay2TP ? overlay2TP.parentNode : null;

    const fontMap = {
      'Noto Serif': '"Noto Serif", serif',
      'Lato': 'Lato, sans-serif',
      'Monotype': '"Courier New", Courier, monospace'
    };

    const maxFontSize = 20;

    const modal = document.getElementById('engraving-modal');


    const state = {
      text1: '',
      text2: '',
      font: 'Noto Serif'
    };

    function selectedFont() {
      const r = root.querySelector('input[name="engraving-font-' + id + '"]:checked');
      return r ? r.value : 'Lato';
    }

    function hasEngraving() {
      return !!(state.text1 || state.text2);
    }

    function updatePreview() {
      state.text1 = (input1?.value || '').slice(0, 30);
      state.text2 = (input2?.value || '').slice(0, 30);
      state.font = selectedFont();

      const fontFamily = fontMap[state.font] || 'Lato, sans-serif';
      const fontLabel = state.font.toLowerCase().includes('mono') ? 'Monotype' : state.font;

      if (overlay1TP) overlay1TP.textContent = state.text1;
      if (overlay2TP) overlay2TP.textContent = state.text2;

      if (overlay1Text) {
        overlay1Text.setAttribute('font-family', fontFamily);
        overlay1Text.setAttribute('font-size', maxFontSize);
      }
      if (overlay2Text) {
        overlay2Text.setAttribute('font-family', fontFamily);
        overlay2Text.setAttribute('font-size', maxFontSize);
      }


      if (hasEngraving()) {
        propEngraving.disabled = false;
        propEngraving.value = `${czcionka}: ${fontLabel}; ${woman}: ${state.text1}; ${man}: ${state.text2}`;
      } else {
        propEngraving.disabled = true;
        propEngraving.value = '';
      }

      document.dispatchEvent(new CustomEvent('engravingFilled', {
        detail: {
          filled: hasEngraving(),
          text: [state.text1, state.text2].filter(Boolean).join(' ')
        }
      }));
    }

    function rehydrateInputs() {
      if (input1) input1.value = state.text1;
      if (input2) input2.value = state.text2;

      const fontRadio = root.querySelector(
        `input[name="engraving-font-${id}"][value="${state.font}"]`
      );
      if (fontRadio) fontRadio.checked = true;
    }

    [input1, input2].forEach(input => {
      input?.addEventListener('input', updatePreview);
    });

    root.querySelectorAll('input[name="engraving-font-' + id + '"]').forEach(r => {
      r.addEventListener('change', updatePreview);
    });

    saveBtn?.addEventListener('click', () => {
      updatePreview();
      if (status) {
        status.textContent = 'Applied';
        setTimeout(() => (status.textContent = ''), 1800);
      }
    });

    resetBtn?.addEventListener('click', () => {
      state.text1 = '';
      state.text2 = '';
      rehydrateInputs();
      updatePreview();
      if (status) {
        status.textContent = 'Cleared';
        setTimeout(() => (status.textContent = ''), 1200);
      }
    });


    if (modal) {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(m => {
          if (m.attributeName === 'aria-hidden' && modal.getAttribute('aria-hidden') === 'false') {
            rehydrateInputs();
            updatePreview();
          }
        });
      });
      observer.observe(modal, { attributes: true });
    }

    updatePreview();
  });
})();